import { Validator } from 'vee-validate'
import Vue from 'vue'
import { Mixin } from 'vue-mixin-decorator'

@Mixin
export default class VeeValidateForm extends Vue {
  $validator: Validator
}
